import { BellRing } from 'lucide-react';
import './private-chat-chime.css';

export function PrivateChatChimeControl({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: () => void;
}) {
  return (
    <div className={`ffs-private-chat-chime ${enabled ? 'enabled' : ''}`}>
      <div>
        <BellRing size={14} />
        <span>Chat chime</span>
      </div>
      <button
        type="button"
        aria-pressed={enabled}
        aria-label={`Private chat chime ${enabled ? 'on' : 'off'}. Click to turn ${enabled ? 'off' : 'on'}.`}
        onClick={onToggle}
      >
        {enabled ? 'ON' : 'OFF'}
      </button>
    </div>
  );
}
